import React from 'react';
import { LockIcon, TrendingUpIcon, AlertTriangleIcon } from 'lucide-react';
export function Header() {
  return <header className="mb-8 border-b border-amber-200 pb-4" data-id="element-144">
      <div className="flex items-center text-xs text-gray-500 mb-2" data-id="element-145">
        <span className="bg-amber-700 text-white px-2 py-0.5 rounded-sm mr-2 uppercase text-[10px] tracking-wider" data-id="element-146">
          Exklusiv rapport
        </span>
        <span data-id="element-147">SPONSRAT INNEHÅLL</span>
      </div>
      <div className="text-sm font-medium text-red-600 mb-2 flex items-center" data-id="element-148">
        <AlertTriangleIcon className="h-4 w-4 mr-1" data-id="element-149" />
        <span data-id="element-150">
          Ny svensk studie: 78% av personer över 40 visar tecken på kognitiv
          försämring utan att veta om det
        </span>
      </div>
      <h1 className="text-3xl md:text-4xl font-bold text-amber-800 mb-4" data-id="element-151">
        "Jag kunde inte komma ihåg mina barnbarns namn" — Upptäck hur detta
        naturliga kosttillskott hjälpte mig att återfå min mentala skärpa efter
        50
      </h1>
      <div className="flex items-center text-sm text-gray-600 mb-4" data-id="element-152">
        <span data-id="element-153">Av Anna Lindström, Medicinsk redaktör</span>
        <span className="mx-2" data-id="element-154">•</span>
        <span data-id="element-155">Granskad av Dr. Erik Johansson, Neurolog</span>
        <span className="mx-2" data-id="element-156">•</span>
        <span data-id="element-157">Uppdaterad: {new Date().toLocaleDateString('sv-SE')}</span>
      </div>
      <div className="bg-amber-50 border-l-4 border-amber-500 p-3 mb-4 text-sm" data-id="element-158">
        <p className="font-medium mb-1" data-id="element-159">
          Forskarvarning: Kognitiv försämring börjar redan vid 30-35 års ålder
        </p>
        <p data-id="element-160">
          Enligt en ny studie från Karolinska Institutet börjar hjärnans
          prestanda minska redan i 30-årsåldern - långt tidigare än de flesta
          tror. Det mest oroväckande: de flesta märker inte försämringen förrän
          det gått för långt.
        </p>
      </div>
      <div className="flex justify-between items-center bg-gray-50 p-2 rounded text-xs text-gray-600 mb-4" data-id="element-161">
        <div className="flex items-center" data-id="element-162">
          <LockIcon className="h-3 w-3 mr-1" data-id="element-163" />
          <span data-id="element-164">Sekretess garanterad</span>
        </div>
        <div className="flex items-center" data-id="element-165">
          <TrendingUpIcon className="h-3 w-3 mr-1" data-id="element-166" />
          <span data-id="element-167">
            <strong data-id="element-168">4,327</strong> läsare den senaste timmen
          </span>
        </div>
      </div>
    </header>;
}